import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { of, switchMap } from 'rxjs';
import { AuthService } from '../../../../core/services/authService';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);

  // Check the authentication status
  const res = of(inject(AuthService).check()).pipe(
    switchMap((authenticated) => {
      // Allow the access
      if (authenticated) router.navigate(['/dashboard']);
      // else window.open(`https://${window.location.hostname}/auth/sign-in`, '_self');
      return of(true);
    })
  );
  res.subscribe((res) => {});
  return res;
};
